function arrayToObject(arr,key){
    return arr.reduce(function(obj,item){
        obj[ item[ key ] ] = item;
        return obj;
    },{});
}

export {arrayToObject};
